"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_QUERY_STRINGS_TO_REDACT = exports.STR_REDACTED = exports.SYNTHETIC_BOT_NAMES = exports.SYNTHETIC_TEST_NAMES = void 0;
/**
 * Names of possible synthetic test sources.
 */
exports.SYNTHETIC_TEST_NAMES = ['alwayson'];
/**
 * Names of possible synthetic bot sources.
 */
exports.SYNTHETIC_BOT_NAMES = ['googlebot', 'bingbot'];
/**
 * REDACTED string used to replace sensitive information in URLs.
 */
exports.STR_REDACTED = 'REDACTED';
/**
 * List of URL query keys that are considered sensitive and whose value should be redacted.
 */
exports.DEFAULT_QUERY_STRINGS_TO_REDACT = [
    'sig',
    'Signature',
    'AWSAccessKeyId',
    'X-Goog-Signature',
];
//# sourceMappingURL=internal-types.js.map